<template>
    <Schema :text="getSchema" v-if="showPrimaryImageSchema"/>
</template>

<script>
  import { mapGetters } from 'vuex';
  import Schema from './json-schema.vue';

  export default {
      name: 'PrimaryImageSchema',
      components: { Schema },
      computed: {
        ...mapGetters('dpp', ['dpp']),
        getSchema() {
            const extensionName = this.dpp.imageFormat || 'jpeg';
            const imageUrl = this.dpp.tnImgPath.replace(/(_[tpr]).(jpeg|webp)/, `_l.${extensionName}`);
            const schema = {
                "@context": "https://schema.org",
                "@type": "WebPage",
                "primaryImageOfPage": {
                    "@type": "ImageObject",
                    "url": imageUrl
                }
            }
            return JSON.stringify(schema);
        },
        showPrimaryImageSchema() {
            return this.dpp.imageDownloaderStatus === 7 && this.dpp.tnImgPath && this.dpp.photoCount > 0;
        },

    },
  };
  </script>